import React from 'react';
import './index.less';

function Row({ row  }) {
	return (
		<tr >
			<td>{row.name}</td>
			<td>{row.admin}</td>
			<td>{row.count}</td>
		</tr>
	);
}

export default Row;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payout-requests/components/table-stat/row.js